
const digest = '99ca605cb1c50ee933e422392cf286c96caa242e4274ee737321f350e55f34f2';
const css = `._lightboxjs_1bv6w_1 {
  margin: 0;
  padding: 0;
}

._lightboxjs_1bv6w_1 * {
  box-sizing: border-box;
}

/* .lightboxjs img,
.lightboxjs svg,
.lightboxjs video {
  display: block;
  vertical-align: middle;
  height: auto;
  max-width: 100%;
} */

._slideshowBtn_1bv6w_37 {
  padding-bottom: 2px;
}

._closeIcon_1bv6w_45:hover,
._closeIcon_1bv6w_45:focus,
._iconsHeader_1bv6w_49 svg:hover,
._iconsHeader_1bv6w_49 svg:focus,
._prev1_1bv6w_53 span:hover,
._next1_1bv6w_55:hover,
._icon_1bv6w_49:hover {
  text-decoration: none;
  cursor: pointer;
  /* color: rgb(230, 230, 230); */
}

._prevIcon_1bv6w_69:hover,
._nextIcon_1bv6w_71:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(230, 230, 230);
}

._show_1bv6w_81 {
  display: flex;
}

._displayHidden_1bv6w_89 {
  display: none;
}

._thumbnail_1bv6w_97 {
  opacity: 1;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

._next1_1bv6w_55 {
  right: 1%;
  padding-left: 2vw;
  padding-right: 3vw;
}

._prev1_1bv6w_53 {
  left: 2%;
  padding-right: 2vw;
}

._thumbnails_1bv6w_133 {
  transition: border 0.3s;
}

._thumbnail_1bv6w_97 {
  display: inline;
}

._thumbnailsWithCaption_1bv6w_149 {
  width: 90%;
}

._thumbnailsOuterContainer_1bv6w_157 {
  position: absolute;
  bottom: 4%;
  height: 5vh;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

._navigationDots_1bv6w_181 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/* Mobile screens */
@media screen and (min-width: 20em) {
  ._imageSlide_1bv6w_197 {
    height: 67vw;
    width: 60%;
  }

  ._thumbnailsOuterContainer_1bv6w_157 {
    position: absolute;
    bottom: 7%;
    width: 100vw;
    /* width: 100%; */
  }

  ._thumbnailsAndCaption_1bv6w_221 {
    height: 23vh;
    bottom: 2%;

  }

  ._hideControlsBar_1bv6w_233 ._slideshowImg_1bv6w_233 {
    /* height: 100vh; */
  }

  ._rotateImgInnerContainer_1bv6w_241 {
    top: 8%;
  }

  ._hideControlsBar_1bv6w_233 ._slideshowInnerContainer_1bv6w_249 {
    top: 0;
  }

  ._thumbnail_1bv6w_97 {
    width: 80px;
    max-width: 80px;
    height: 7vh;
  }

  ._videoThumbnailsOuterContainer_1bv6w_269 {
    bottom: 2%;
  }

  ._imgTitleContainer_1bv6w_277 {
    padding-bottom: 16px;
    width: 100vw;
    margin-top: 0;
    margin-bottom: 0;
  }

  ._thumbnails_1bv6w_133 {
    margin-left: auto;
    margin-right: auto;
  }

  ._next1_1bv6w_55 {
    right: 0.9%;
  }

  ._prev1_1bv6w_53 {
    left: 1.5%;
  }
}

._thumbnail_1bv6w_97 {
  height: 5vh;
  border-radius: 6px;
  margin-right: 7px;
  object-fit: cover;
}



._thumbnailsOuterContainerMetadata_1bv6w_337 {
  width: 78vw;
}

._videoThumbnailsOuterContainer_1bv6w_269 {
  bottom: 5%;
}

._thumbnailsAndCaption_1bv6w_221 {
  height: 19vh;
}

._htmlVideoOuterContainer_1bv6w_361 video {
  height: 100%;
  max-height: 70vh;
  width: 100%;
}

._caption_1bv6w_373 {
  position: absolute;
  bottom: 14%;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

._galleryImg_1bv6w_393 {
  cursor: pointer;
  margin: 0.2em;
}

._modalContainer_1bv6w_403 {
  width: 100vw;
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
}

._slideshowAnimContainer_1bv6w_441 {
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000000;
}

._fullScreenContainer_1bv6w_477 img {
  height: 100vh;
  max-width: 100%;
  /* max-height: 100vh; */
}

._imageInnerContainer_1bv6w_489 img {
  height: 80vh;
  max-width: 100%;
  max-height: 100%;
}

._imageInnerContainer_1bv6w_489 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._magnifyWrapper_1bv6w_527 {
  margin-bottom: 3em;
  margin-left: auto;
  margin-right: auto;
}

._slideshowInnerContainer_1bv6w_249 {
  position: fixed; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: top 0.2s ease-in-out 0s;
  top: 12%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._slideshowInnerVideoContainer_1bv6w_567 {
  top: 6%;
}

._slideshowInnerContainerThumbnails_1bv6w_575 {
  top: 12%;
}

._hideControlsBar_1bv6w_233  {
  top: 0;
}

._fullScreenContainer_1bv6w_477 {
  top: 0;
}

._lightboxContainer_1bv6w_599 {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

._next1_1bv6w_55,
._prev1_1bv6w_53 {
  top: calc(50% - 20px);
  position: absolute;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  padding-bottom: 2vh;
  padding-top: 2vh;
  user-select: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;
  width: 40px;
  height: 40px;
  font-size: 18px;
  z-index: 10000000;
}



._next1_1bv6w_55:hover,
._prev1_1bv6w_53:hover {
  color: rgb(230, 230, 230);
}

._slideshowAnimImg_1bv6w_671 {
  position: absolute;
  max-width: 100vw;
}

._controls_1bv6w_681 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

._iconsHeader_1bv6w_49 {
  color: white;
  position: absolute;
  display: flex;
  flex-direction: row;
  /* align-items: center;
    justify-content: center; */
  cursor: pointer;
  top: 10px;
  right: 45px;
  z-index: 999999999;
  /* padding: 0.14vw; */
}

._ytVideo_1bv6w_721 {
  aspect-ratio: 16 / 9;
  height: 65vh;
  width: 100%;
}

._videoOuterContainer_1bv6w_733 {
  width: 65%;
  margin-left: auto;
  margin-right: auto;
  height: 60vh;
  max-height: 65vh;
}

._htmlVideoOuterContainer_1bv6w_361 {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._customVideoContainer_1bv6w_761, ._customEmbedContainer_1bv6w_761 {
  margin-left: auto;
  margin-right: auto;
}

._videoIconsHeader_1bv6w_771 {
  position: fixed;
  top: 4%;
  right: 3%;
}

._lightbox_1bv6w_1 ._iconsHeader_1bv6w_49 svg {
  transition: 0.3s all;
}

._iconsHeader_1bv6w_49 svg:active {
  transform: scale(0.97);
}

._imgTitle_1bv6w_277 {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._iconsHeader_1bv6w_49 svg {
  margin-left: 0.6em;
  padding: 0.2em;
  transition: all 0.1s;
  /* width: 32px;  */
  /* font-size: 18px; */
  line-height: 16px;
  vertical-align: baseline;
}

._icon_1bv6w_49 {
  /* width: 32px;  */
}

@media screen and (min-width: 6em) {
  ._iconsHeader_1bv6w_49 {
    top: 3%;
  }

  ._slideshowAnimContainer_1bv6w_441 {
    width: 100vw;
  }

  ._iconsHeader_1bv6w_49 svg {
    /* width: 34px;  */
    padding-right: 0.3em;
  }

  ._lightboxjs_1bv6w_1 img {
    cursor: pointer;
  }

  ._thumbnail_1bv6w_97 {
    height: 9vh;
    /* width: 22vw; */
  }

  ._next1_1bv6w_55 {
    top: calc(48% - 20px);
  }

  ._prev1_1bv6w_53 {
    top: calc(48% - 20px);

  }


}

@media screen and (min-width: 39em) {
  ._slideshowAnimContainer_1bv6w_441 {
    width: 100vw;
  }

  ._slideshowInnerContainer_1bv6w_249 {
    /* width: 100vw;
    height: 95vh;
    position: absolute; */
  }

  ._imgTitleContainer_1bv6w_277 {
    padding-bottom: 0px;
  }
  

  ._next1_1bv6w_55 {
    right: 0.7%;
  }

  /* .thumbnailsOuterContainer {
    bottom: 10%;
  } */

  /* .hideControlsBar .slideshow_img {
    height: 70vh;

  }

  .hideControlsBar {
    top: 10%;
  } */

  ._fullScreenContainer_1bv6w_477 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._fullScreenContainer_1bv6w_477 img {
    height: 100vh;
  }

  ._thumbnails_1bv6w_133 {
    margin-top: 0.6em;
  }

  ._thumbnail_1bv6w_97 {
    /* height: 8vh; */
    width: 80px;
    max-width: 80px;
  }

  ._iconsHeader_1bv6w_49 svg {
    /* width: 32px; 
      font-size: 32px; */
  }

  ._prev1_1bv6w_53 {
    left: 2.7%;
    padding-right: 2vw;
  }
}

/* Desktop screens */
@media screen and (min-width: 42em) {
  ._imageSlide_1bv6w_197 {
    height: 70vh;
    width: 80vw;
  }

  ._innerContainerWithTopCaption_1bv6w_1051 {
    top: 8%;
  }

  ._slideshowImgFullscreen_1bv6w_1059 {
    display: grid;
    width: 92vw;
    place-items: start;
    margin-left: auto;
    margin-right: auto;
    scrollbar-gutter: stable both-edges;
  }

  ._thumbnailsAndCaption_1bv6w_221 {
    bottom: 0%;
  }
  
  ._rotateImgInnerContainer_1bv6w_241 {
    top: 2%;
  }

  ._slideshowInnerContainer_1bv6w_249 img {
    margin-top: 0vh;
    /* width: 70vw; */
  }

  ._fullScreenContainer_1bv6w_477 img {
    width: 80vw;
  }

  ._slideshowInnerContainerFullScreen_1bv6w_1111 {
    top: 0%;
  }

  ._fullScreenLightboxImg_1bv6w_1119 {
    margin-left: auto;
    margin-right: auto;
    height: 100vh;
  }

  ._slideshowInnerContainerImgMetadata_1bv6w_1131 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  ._slideshowInnerContainerFullScreen_1bv6w_1111 {
    height: 100vh;
    width: 100vw;
    position: absolute;
  }

  ._slideshowInnerContainerFullScreen_1bv6w_1111 img {
    object-fit: contain;
  }

  ._thumbnails_1bv6w_133 {
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 1.1em;
  }

  ._thumbnails_1bv6w_133::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ._opacity-fade_1bv6w_1185 {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    opacity: 1;
  }

  ._thumbnailsOuterContainer_1bv6w_157 {
    margin-top: 0.1em;
    padding-top: 0.3em;
    height: 5vh;
    bottom: 11%;
  }

  ._thumbnailsAndCaption_1bv6w_221 {
    bottom: 0%;
  }

  ._thumbnail_1bv6w_97,
  ._imageSliderThumbnails_1bv6w_1221 img {
    height: 10vh;
    /* width: 7em; */
  }

  ._slideshowAnimContainer_1bv6w_441 {
    width: 100vw;
  }

  /* .slideshowInnerContainer {
    width: 100vw;
    height: 95vh;
  } */

  ._hideControlsBar_1bv6w_233 {
    /* height: 100vh; */
  }

  ._fullScreenContainer_1bv6w_477 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._iconsHeader_1bv6w_49 svg {
    /* width: 37px;
      font-size: 34px; */
  }

  ._prev1_1bv6w_53 {
    left: 2%;
    padding-right: 2vw;
  }

  ._next1_1bv6w_55 {
    right: 0.4%;
  }

  
  ._slideshowImgMetadata_1bv6w_1297 {
    width: 78vw;
  }

  ._prev1Metadata_1bv6w_1305 {
    left: 1%;
  }

  ._navigationDots_1bv6w_181 {
    gap: 8px;
  }

 
}

@media screen and (min-width: 53em) {
  
  ._slideshowImg_1bv6w_233 {
    display: grid;
    width: 100vw;
    height: 70vh;
    place-items: start;
    /* margin-top: 7vh; */
  }

  ._slideshowImgWithCaption_1bv6w_1347 {
    height: 68vh;
  }

  ._hideControlsBar_1bv6w_233 ._slideshowImg_1bv6w_233, ._hideControlsBarAndCaption_1bv6w_1355 ._slideshowImg_1bv6w_233  {
    padding-top: 12vh;
  }

  ._fullScreenContainer_1bv6w_477 ._slideshowImg_1bv6w_233 {
    padding-top: 0vh;
  }


  ._lightboxImg_1bv6w_1373 {
      /* height: 70vh; */
  }

  ._thumbnail_1bv6w_97 {
    width: 95px;
    max-width: 80px;
  } 

  ._slideshowImgMetadata_1bv6w_1297 {
    width: 78vw;
  }
}
  

@media screen and (min-width: 80em) {
  ._slideshowInnerContainer_1bv6w_249 img {
    /* width: 60vw; */
  }

  ._fullScreenContainer_1bv6w_477 img {
    width: 80vw;
  }
}

._lightIcon_1bv6w_1423,
._lightIcon_1bv6w_1423 svg {
  background-color: white;
  color: black;
}

._lightIcon_1bv6w_1423:hover,
._lightIcon_1bv6w_1423 svg:hover {
  background-color: white;
  color: black;
  fill: black;
}

._darkIcon_1bv6w_1449,
._darkIcon_1bv6w_1449 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: silver;
  fill: silver;
}

._darkIcon_1bv6w_1449:hover,
._darkIcon_1bv6w_1449 svg:hover {
  color: rgba(107, 107, 107, 0.8);
  fill: rgba(107, 107, 107, 0.8);
}

/* Header icons  */
._lightHeaderIcon_1bv6w_1479 svg {
  background-color: white;
  color: black;
  fill: black;
}

._lightHeaderIcon_1bv6w_1479 svg:hover {
  background-color: white;
  color: rgb(24, 24, 24, 0.8);
  fill: rgb(24, 24, 24, 0.8);

}

._darkHeaderIcon_1bv6w_1505 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: #626b77;
  fill: #626b77;
}

._darkHeaderIcon_1bv6w_1505 svg:hover {
  color: rgba(99, 99, 99, 0.8);
  fill: rgba(99, 99, 99, 0.8);
}

._magnifierImage_1bv6w_1529 {
  object-fit: contain;
}

._thumbnails_1bv6w_133 ._active_1bv6w_1537 {
  border: solid rgb(107, 133, 206) 2px;
}

._inactiveThumbnailBorder_1bv6w_1545 {
  border: solid transparent 2px;
}

._thumbnails_1bv6w_133 {
  width: 95%;
}

._emblaThumbs_1bv6w_1561 {
  --thumbs-slide-spacing: 2px; 
  /* --thumbs-slide-height: 9rem; */
  margin-top: var(--thumbs-slide-spacing);
}

@media screen and (max-width: 40em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  ._imgTitleContainer_1bv6w_277 {
    /* position: absolute;
    top: 12%; */
  }

  ._slideshowImg_1bv6w_233 {
    height: 100vh;
  }
}

@media screen and (max-width: 53em) {
  ._fullScreenSlideshowImg_1bv6w_1607 {
    margin-top: auto;
    margin-bottom: auto;
  }
}

@media screen and (max-width: 44em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */
  ._thumbnailsOuterContainer_1bv6w_157 {
    bottom: 11%;
  }

  ._thumbnailsAndCaption_1bv6w_221 {
    bottom: 4%;
  }
  
  ._imgTitleContainer_1bv6w_277 {
    /* position: absolute;
    top: 5%; */
  }
}

@media screen and (max-width: 46em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  /* .imgTitleContainer {
    position: absolute;
    top: 7%;
  } */
}

@media screen and (max-width: 49em) and (min-width: 45em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  /* .imgTitleContainer {
    position: absolute;
    top: 5%;
  } */
}

@media screen and (max-width: 29em) {
  ._fullScreenContainer_1bv6w_477 img {
    object-fit: cover;
  }

  ._emblaThumbs_1bv6w_1561 {
    --thumbs-slide-spacing: 3px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }



  ._htmlVideo_1bv6w_361 {
    margin-top: 5vh;
  }

  ._thumbnails_1bv6w_133 {
    width: 98%;
  }

  ._thumbnail_1bv6w_97 {
    width: 80px;
    max-width: 80px;
  }

  ._htmlVideoOuterContainer_1bv6w_361 video {
    max-height: 65vh;
  }

  ._videoIconsHeader_1bv6w_771 {
    position: fixed;
    top: 2%;
    right: 15px;
  }

  ._videoOuterContainer_1bv6w_733 {
    width: 88%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    max-height: 65vh;
  }

  ._htmlVideoOuterContainer_1bv6w_361 {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
  }

  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 115px;
  }

  ._slideshowInnerVideoContainer_1bv6w_567 {
    top: 3%;
  }

  ._next1_1bv6w_55,
  ._prev1_1bv6w_53 {
    padding-bottom: 2vh;
    padding-top: 2vh;
  }

  ._next1_1bv6w_55 {
    padding-left: 4vw;
  }

  ._prev1_1bv6w_53 {
    padding-right: 4vw;
  }

  ._iconsHeader_1bv6w_49 {
    /* font-size: 28px; */
  }

}

@media screen and (max-width: 53em) {
  ._slideshowImg_1bv6w_233 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  ._slideshowImg_1bv6w_233 img {
    margin-left: auto;
    margin-right: auto;
  }

  ._slideshowInnerContainerFullScreen_1bv6w_1111 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }

  ._containImg_1bv6w_1917 {
    object-fit: contain;
  }
}

._fullScreenContainer_1bv6w_477 img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

._thumbnails_1bv6w_133 {
  text-align: center;
  white-space: nowrap;
}

._reactTransformComponent_1bv6w_1949 {
  margin-left: auto;
  margin-right: auto;
}

._magnifierImage_1bv6w_1529 {
  margin-left: auto;
  margin-right: auto;
}

/* CSS loader  */
._loader_1bv6w_1971 {
  width: 44px;
  height: 44px;
  box-sizing: border-box;

  border-radius: 50%;

  display: inline-block;
  position: fixed;
  top: 35%;
  left: 50%;
  animation: _rotation_1bv6w_1 1s linear infinite;
}

@keyframes _rotation_1bv6w_1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

._dayLoader_1bv6w_2017 {
  border: 5px solid #626b77;
  border-bottom-color: transparent;
}

._nightLoader_1bv6w_2027 {
  border: 5px solid #fff;
  border-bottom-color: transparent;
}

._lightboxImg_1bv6w_1373 {
  max-height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

._controls_1bv6w_681 button, ._closeButton_1bv6w_2049, ._closeButtonRounded_1bv6w_2049 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}

._controls_1bv6w_681 svg {
  box-sizing: border-box;
}

._closeButton_1bv6w_2049 svg, ._closeButtonRounded_1bv6w_2049 svg {
  box-sizing: border-box;
  font-size: 16px;
  padding-top: 0.5px;
}

._closeButton_1bv6w_2049 {
  padding-top: 3px;
}

._closeButtonRounded_1bv6w_2049 {
  cursor: pointer;

}

._closeButtonRounded_1bv6w_2049 svg {
  margin: 0;
  padding: 5px;
  background-color: black;
  border-color: transparent;
  border-radius: 28px;

}

._thumbnailsAndCaption_1bv6w_221 {
  height: 19vh;
  margin-top: 0em;
  width: 100vw;
}

._thumbnailsWithCaption_1bv6w_149 {
  margin-top: 0em;
}

._slideImageAndCaption_1bv6w_2141 {
  top: 9%;
}

._slideImageAndCaption_1bv6w_2141._hideControlsBar_1bv6w_233 {
  top: 0;
}

._slideshowAnimContainer_1bv6w_441 {
  -ms-overflow-style: none;
  /* scrollbar-width: none;   */
}
._thumbnails_1bv6w_133::-webkit-scrollbar {
  display: none;
}

._roundedBorder_1bv6w_2173 {
  border-radius: 20px;
}

._maxWidthFull_1bv6w_2181 {
  max-width: 100%;
}

._maxWidthWithoutMagnifier_1bv6w_2189 {
  max-width: 80%;
}

@media screen and (max-width: 880px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    right: 5%;
  }
}

@media screen and (max-width: 480px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 180px;
  }
  
}

@media screen and (max-width: 440px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 160px;
  }
}

@media screen and (max-width: 410px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 140px;
  }
}

@media screen and (max-width: 385px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 135px;
    /* top: 24px; */
  }
}

@media screen and (max-width: 365px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 90px;
  }
}

@media screen and (max-width: 345px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 94px;
  }
}

@media screen and (max-width: 325px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 60px;
  }
}

@media screen and (max-width: 300px) {
  ._iconsHeader_1bv6w_49 {
    position: fixed;
    left: 30px;
  }
}

._lightboxVideo_1bv6w_2327 {
  margin-left: auto;
  margin-right: auto;
}

._navigation-wrapper_1bv6w_2337 {
  position: relative;
}

._dots_1bv6w_2345 {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

._dot_1bv6w_2345 {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}

._dot_1bv6w_2345:focus {
  outline: none;
}

._dot_1bv6w_2345._active_1bv6w_1537 {
  background: #000;
}

._arrow_1bv6w_2395 {
  position: absolute;
  top: 50%;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.2s;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: sans-serif;
}

._leftArrow_1bv6w_2425 {
  left: 8px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._rightArrow_1bv6w_2439 {
  left: auto;
  right: 8px;
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._arrow_1bv6w_2395:hover {
  color: rgb(230, 230, 230);
}

._arrow--disabled_1bv6w_2463,
._arrow--disabled_1bv6w_2463:hover {
  color: rgba(255, 255, 255, 0.5);
}

._navDotsMargin_1bv6w_2473 {
  margin-top: 12px;
}

._inactiveThumbnailBorderImgSlider_1bv6w_2481 {
  border: 'solid transparent 2px';
}

._ytVideoImgSlider_1bv6w_2489 {
  width: 100%;
  height: 100%;
}

._ytVideoImgSlider_1bv6w_2489 iframe {
  width: 100%;
  height: 100%;
}

._outerYTVideoImgSlider_1bv6w_2509 {
  height: 100%;
}

._lightboxjs_1bv6w_1 iframe {
  margin: none;
  padding: none;
  border: none;
}

._imgSliderArrow_1bv6w_2529 {
  z-index: 100000;
  background-color: transparent;
  border: none;
}

._thumbnails_1bv6w_133 {
  margin-left: auto;
  margin-right: auto;
}

._cursorPointer_1bv6w_2551 {
  cursor: pointer;
}

._lightboxjsIcon_1bv6w_2559 > * { color: inherit; fill: inherit }

._embla_1bv6w_1561 {
  margin-left: auto;
  margin-right: auto;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-height: 19rem;
}

._emblaViewport_1bv6w_2579 {
  overflow: hidden;
  width: 100vw;
}

._emblaContainer_1bv6w_2589 {
  backface-visibility: hidden; 
  touch-action: pan-y;
  height: auto;
  margin-left: calc(var(--slide-spacing) * -1);
  display: grid;  
  grid-auto-flow: column;  
  grid-auto-columns: 100%; 
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto; 
  /* width: 80%;
*/
}

._emblaContainerImgMetadata_1bv6w_2619 {
  width: 78vw;
  max-width: 78vw;
  height: 80vh;
}

._imgdrag_1bv6w_2631 ._emblaSlide_1bv6w_2631 {
  flex: 0 0 80%;
  min-width: 0;
  max-width: 100%;
  padding-left: 12px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

._emblaThumbsViewport_1bv6w_2651 {
  overflow: hidden;
}

._emblaThumbsContainer_1bv6w_2659 {
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
  width: 100%;
  /* align-items: center;
  text-align: center;
  width: fit-content; */
  /* justify-content: center; */
  
}

._emblaThumbsContainer_1bv6w_2659::before, ._emblaThumbsContainer_1bv6w_2659::after {
  content: '';  /* Insert pseudo-element */
  margin: auto; /* Make it push flex items to the center */
}


._emblaThumbsSlide_1bv6w_2695 {
  /* min-width: 0; */
  padding-left: var(--thumbs-slide-spacing);
  /* position: relative; */
  /* width: 140px; */
}

._emblaThumbsSlideImg_1bv6w_2709 {
  /* display: block; */
  height: var(--thumbs-slide-height);
  width: 100%;
  object-fit: cover;
}

._mlAuto_1bv6w_2723 {
  margin-left: auto;
}

._metadata_1bv6w_2731 {
  color: white;
}

._emblaSlideGrid_1bv6w_2739 {
  display: flex;
}

._metadata_1bv6w_2731 {
  text-align: left;
  min-width: 17vw;
  max-width: 17vw;
  padding-top: 5vw;
}

._metadataPanel_1bv6w_2761 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

._metadataInnerContainer_1bv6w_2773 {
  padding-left: 7vw;
}

._metadataInnerContainer_1bv6w_2773 span {
  display: block;
}


._imgMetadataCloseBtn_1bv6w_2791 {
  position: absolute;
  top: 1%;
  right: 2%;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

/* Styling from react-zoom-pan-pinch library */
._reactTransformWrapper_1bv6w_2813 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -khtml-user-select: none; /* Konqueror HTML */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}

._reactTransformComponent_1bv6w_1949 {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}

._reactTransformComponent_1bv6w_1949 img {
  pointer-events: none;
}

._navigationDot_1bv6w_181 {
  height: 10px;
  width: 10px;
  background-color: silver;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

._navigationDotContainer_1bv6w_2897 {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

._imgfade_1bv6w_2911._emblaContainer_1bv6w_2589 {
  transform: none !important; /* override Embla */
  display: flex;
  /* height: 250px; */
}

._notFullScreen_1bv6w_2923 {
  top: 0;
}

._imgfade_1bv6w_2911._emblaSlide_1bv6w_2631 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: 0; */
  left: 0 !important; /* override Embla */
  right: 0 !important; /* override Embla */
  opacity: 0;
  transition: opacity 0.5s;
  counter-increment: embla;
  border-radius: 0.5rem;
}

._imgFadeWithTopCaption_1bv6w_2959 {
  top: 16%;
  position: fixed;
}

._imgfade_1bv6w_2911._emblaSlideSelected_1bv6w_2969 {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 1;
}

._imgfade_1bv6w_2911._emblaSlide_1bv6w_2631:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

._fullImg_1bv6w_2995 {
  height: 84vh;
  max-height: 84vh;
  object-fit: contain;
}

._rotateImg90Deg_1bv6w_3007{
transform: rotate(90deg);
transition: transform 1s linear;
}  

._rotate_img_1bv6w_3017 {
transition: transform 0.7s linear;
}

._fullScreenContainer_1bv6w_477 img {
/* max-height: 100vh; */
}

._slideshowImg_1bv6w_233 img {
height: 100%;
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"lightboxjs":"_lightboxjs_1bv6w_1","slideshowBtn":"_slideshowBtn_1bv6w_37","closeIcon":"_closeIcon_1bv6w_45","iconsHeader":"_iconsHeader_1bv6w_49","prev1":"_prev1_1bv6w_53","next1":"_next1_1bv6w_55","icon":"_icon_1bv6w_49","prevIcon":"_prevIcon_1bv6w_69","nextIcon":"_nextIcon_1bv6w_71","show":"_show_1bv6w_81","displayHidden":"_displayHidden_1bv6w_89","thumbnail":"_thumbnail_1bv6w_97","thumbnails":"_thumbnails_1bv6w_133","thumbnailsWithCaption":"_thumbnailsWithCaption_1bv6w_149","thumbnailsOuterContainer":"_thumbnailsOuterContainer_1bv6w_157","navigationDots":"_navigationDots_1bv6w_181","imageSlide":"_imageSlide_1bv6w_197","thumbnailsAndCaption":"_thumbnailsAndCaption_1bv6w_221","hideControlsBar":"_hideControlsBar_1bv6w_233","slideshowImg":"_slideshowImg_1bv6w_233","rotateImgInnerContainer":"_rotateImgInnerContainer_1bv6w_241","slideshowInnerContainer":"_slideshowInnerContainer_1bv6w_249","videoThumbnailsOuterContainer":"_videoThumbnailsOuterContainer_1bv6w_269","imgTitleContainer":"_imgTitleContainer_1bv6w_277","thumbnailsOuterContainerMetadata":"_thumbnailsOuterContainerMetadata_1bv6w_337","htmlVideoOuterContainer":"_htmlVideoOuterContainer_1bv6w_361","caption":"_caption_1bv6w_373","galleryImg":"_galleryImg_1bv6w_393","modalContainer":"_modalContainer_1bv6w_403","slideshowAnimContainer":"_slideshowAnimContainer_1bv6w_441","fullScreenContainer":"_fullScreenContainer_1bv6w_477","imageInnerContainer":"_imageInnerContainer_1bv6w_489","magnifyWrapper":"_magnifyWrapper_1bv6w_527","slideshowInnerVideoContainer":"_slideshowInnerVideoContainer_1bv6w_567","slideshowInnerContainerThumbnails":"_slideshowInnerContainerThumbnails_1bv6w_575","lightboxContainer":"_lightboxContainer_1bv6w_599","slideshowAnimImg":"_slideshowAnimImg_1bv6w_671","controls":"_controls_1bv6w_681","ytVideo":"_ytVideo_1bv6w_721","videoOuterContainer":"_videoOuterContainer_1bv6w_733","customVideoContainer":"_customVideoContainer_1bv6w_761","customEmbedContainer":"_customEmbedContainer_1bv6w_761","videoIconsHeader":"_videoIconsHeader_1bv6w_771","lightbox":"_lightbox_1bv6w_1","imgTitle":"_imgTitle_1bv6w_277","innerContainerWithTopCaption":"_innerContainerWithTopCaption_1bv6w_1051","slideshowImgFullscreen":"_slideshowImgFullscreen_1bv6w_1059","slideshowInnerContainerFullScreen":"_slideshowInnerContainerFullScreen_1bv6w_1111","fullScreenLightboxImg":"_fullScreenLightboxImg_1bv6w_1119","slideshowInnerContainerImgMetadata":"_slideshowInnerContainerImgMetadata_1bv6w_1131","opacityFade":"_opacity-fade_1bv6w_1185","imageSliderThumbnails":"_imageSliderThumbnails_1bv6w_1221","slideshowImgMetadata":"_slideshowImgMetadata_1bv6w_1297","prev1Metadata":"_prev1Metadata_1bv6w_1305","slideshowImgWithCaption":"_slideshowImgWithCaption_1bv6w_1347","hideControlsBarAndCaption":"_hideControlsBarAndCaption_1bv6w_1355","lightboxImg":"_lightboxImg_1bv6w_1373","lightIcon":"_lightIcon_1bv6w_1423","darkIcon":"_darkIcon_1bv6w_1449","lightHeaderIcon":"_lightHeaderIcon_1bv6w_1479","darkHeaderIcon":"_darkHeaderIcon_1bv6w_1505","magnifierImage":"_magnifierImage_1bv6w_1529","active":"_active_1bv6w_1537","inactiveThumbnailBorder":"_inactiveThumbnailBorder_1bv6w_1545","emblaThumbs":"_emblaThumbs_1bv6w_1561","fullScreenSlideshowImg":"_fullScreenSlideshowImg_1bv6w_1607","htmlVideo":"_htmlVideo_1bv6w_361","containImg":"_containImg_1bv6w_1917","reactTransformComponent":"_reactTransformComponent_1bv6w_1949","loader":"_loader_1bv6w_1971","rotation":"_rotation_1bv6w_1","dayLoader":"_dayLoader_1bv6w_2017","nightLoader":"_nightLoader_1bv6w_2027","closeButton":"_closeButton_1bv6w_2049","closeButtonRounded":"_closeButtonRounded_1bv6w_2049","slideImageAndCaption":"_slideImageAndCaption_1bv6w_2141","roundedBorder":"_roundedBorder_1bv6w_2173","maxWidthFull":"_maxWidthFull_1bv6w_2181","maxWidthWithoutMagnifier":"_maxWidthWithoutMagnifier_1bv6w_2189","lightboxVideo":"_lightboxVideo_1bv6w_2327","navigationWrapper":"_navigation-wrapper_1bv6w_2337","dots":"_dots_1bv6w_2345","dot":"_dot_1bv6w_2345","arrow":"_arrow_1bv6w_2395","leftArrow":"_leftArrow_1bv6w_2425","rightArrow":"_rightArrow_1bv6w_2439","arrowDisabled":"_arrow--disabled_1bv6w_2463","navDotsMargin":"_navDotsMargin_1bv6w_2473","inactiveThumbnailBorderImgSlider":"_inactiveThumbnailBorderImgSlider_1bv6w_2481","ytVideoImgSlider":"_ytVideoImgSlider_1bv6w_2489","outerYtVideoImgSlider":"_outerYTVideoImgSlider_1bv6w_2509","imgSliderArrow":"_imgSliderArrow_1bv6w_2529","cursorPointer":"_cursorPointer_1bv6w_2551","lightboxjsIcon":"_lightboxjsIcon_1bv6w_2559","embla":"_embla_1bv6w_1561","emblaViewport":"_emblaViewport_1bv6w_2579","emblaContainer":"_emblaContainer_1bv6w_2589","emblaContainerImgMetadata":"_emblaContainerImgMetadata_1bv6w_2619","imgdrag":"_imgdrag_1bv6w_2631","emblaSlide":"_emblaSlide_1bv6w_2631","emblaThumbsViewport":"_emblaThumbsViewport_1bv6w_2651","emblaThumbsContainer":"_emblaThumbsContainer_1bv6w_2659","emblaThumbsSlide":"_emblaThumbsSlide_1bv6w_2695","emblaThumbsSlideImg":"_emblaThumbsSlideImg_1bv6w_2709","mlAuto":"_mlAuto_1bv6w_2723","metadata":"_metadata_1bv6w_2731","emblaSlideGrid":"_emblaSlideGrid_1bv6w_2739","metadataPanel":"_metadataPanel_1bv6w_2761","metadataInnerContainer":"_metadataInnerContainer_1bv6w_2773","imgMetadataCloseBtn":"_imgMetadataCloseBtn_1bv6w_2791","reactTransformWrapper":"_reactTransformWrapper_1bv6w_2813","navigationDot":"_navigationDot_1bv6w_181","navigationDotContainer":"_navigationDotContainer_1bv6w_2897","imgfade":"_imgfade_1bv6w_2911","notFullScreen":"_notFullScreen_1bv6w_2923","imgFadeWithTopCaption":"_imgFadeWithTopCaption_1bv6w_2959","emblaSlideSelected":"_emblaSlideSelected_1bv6w_2969","fullImg":"_fullImg_1bv6w_2995","rotateImg90Deg":"_rotateImg90Deg_1bv6w_3007","rotateImg":"_rotate_img_1bv6w_3017"};
export { css, digest };
  